export * from './lookup-table-entry.entity';

